module.exports = __webpack_public_path__ + "img/0.450909c1.jpg";